"use client";

import "@/amplify/amplifyconfig";

export default function AuthLayout({ children }) {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-muted p-6 md:p-10 
    bg-[url('/power2go-mobile-bg.png')] md:bg-[url('/p2go-bg.png')] md:bg-cover md:bg-no-repeat md:bg-center
    bg-cover bg-center">
      <div className="w-full">
        {children}
      </div>
    </div>
  );
}